/**
 * Lead Status Badge Component
 * Displays the current status of an insurance lead with appropriate styling
 */

import React from 'react';
import { LeadStatus, LEAD_STATUS_CONFIG } from '../../types/insurance';

interface LeadStatusBadgeProps {
  status: LeadStatus;
  size?: 'sm' | 'md';
}

export const LeadStatusBadge: React.FC<LeadStatusBadgeProps> = ({
  status,
  size = 'md',
}) => {
  const config = LEAD_STATUS_CONFIG[status];

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-1 text-sm';

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ${config.bgColor} ${config.color} ${sizeClasses}`}
      title={config.description}
    >
      {config.label}
    </span>
  );
};

export default LeadStatusBadge;
